import { getColorHexCodeByColorName } from "~/common/utilities/pageUtils";

export interface QTooltipAnchorIconProps {
  id: string;
  colorName?: string;
}
const QTooltipAnchorIcon = ({
  id,
  colorName = "primary-gray-light-400",
}: QTooltipAnchorIconProps) => {
  const color = getColorHexCodeByColorName(colorName);
  return (
    <svg
      className="tooltip-trigger"
      xmlns="http://www.w3.org/2000/svg"
      id={`${id}-tooltip-icon`}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M5.39366 5.9987C5.5504 5.55314 5.85976 5.17744 6.26696 4.93812C6.67416 4.6988 7.15292 4.61132 7.61844 4.69117C8.08396 4.77102 8.5062 5.01305 8.81038 5.37438C9.11455 5.73572 9.28103 6.19305 9.28033 6.66536C9.28033 7.9987 7.28033 8.66536 7.28033 8.66536M7.33366 11.332H7.34033M14.0003 7.9987C14.0003 11.6806 11.0156 14.6654 7.33366 14.6654C3.65176 14.6654 0.666992 11.6806 0.666992 7.9987C0.666992 4.3168 3.65176 1.33203 7.33366 1.33203C11.0156 1.33203 14.0003 4.3168 14.0003 7.9987Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default QTooltipAnchorIcon;